<template>
  <div class="text-center">
    <v-dialog v-model="show" width="500">
      <v-card>
        <v-card-title class="justify-left">
          <h1 class="headline primary--text text--accent-2">
            {{ title }}
            <v-icon
              class="pt-3 pr-3"
              style="right:0px;top:0px;position:absolute;"
              color="primary"
              medium
              @click="show = false"
              >mdi-close</v-icon
            >
          </h1>
        </v-card-title>
        <v-divider></v-divider>
        <form class="user-creation-form">
          <v-card class="justify-center mb-5 my-5"> </v-card>
          <v-card-text>
            <CustomAlert :show-alert="submitError" alert-type="error">
              <span class="body-2">{{ loginErrorMsg }}</span>
            </CustomAlert>
            <v-text-field
              id="firstName"
              v-model="firstName"
              class="cms_firstName"
              :label="$cmsService.getContent(content, 'first_name')"
              :error-messages="firstNameErrors"
              outlined
              dense
              required
              @input="$v.firstName.$touch()"
              @keyup.enter.native="submit()"
            ></v-text-field>
            <v-text-field
              id="lastName"
              v-model="lastName"
              class="cms_lastName"
              :label="$cmsService.getContent(content, 'last_name')"
              :error-messages="lastNameErrors"
              outlined
              dense
              required
              @input="$v.lastName.$touch()"
              @keyup.enter.native="submit()"
            ></v-text-field>
            <v-text-field
              id="email"
              v-model="email"
              class="cms_eMail"
              :label="$cmsService.getContent(content, 'email_address')"
              :error-messages="emailErrors"
              outlined
              dense
              required
              @input="$v.email.$touch()"
              @keyup.enter.native="submit()"
            ></v-text-field>
            <v-text-field
              id="password"
              v-model="pwd"
              class="cms_pw"
              :label="$cmsService.getContent(content, 'password')"
              :error-messages="pwdErrors"
              :type="showPwd ? 'text' : 'password'"
              :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
              outlined
              dense
              required
              @input="$v.pwd.$touch()"
              @keyup.enter.native="submit()"
              @click:append="showPwd = !showPwd"
            ></v-text-field>
            <v-checkbox
              v-model="isAdmin"
              color="primary"
              class="ml-3"
              :label="$cmsService.getContent(content, 'get_administrations')"
            ></v-checkbox>
          </v-card-text>
        </form>
        <v-divider class="py-1"></v-divider>
        <v-card-actions class="pr-3 pb-3">
          <v-btn
            color="grey"
            class="white--text text-capitalize"
            @click="show = false"
            ><span>{{ $cmsService.getContent(content, 'cancel') }}</span></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="white--text text-capitalize"
            @click="submit"
            ><span>{{ button }}</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { userService } from '@/services'
import CustomAlert from '../CustomAlert'
import loginForm from '@/data/json/forms/forms'
import dialogJson from '@/data/dialog.json'
import userJson from '@/data/json/tables/user.json'

export default {
  name: 'UserDialog',
  components: { CustomAlert },
  mixins: [validationMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: ''
    },
    fetchUsers: {
      type: Function
    },
    userUpdateId: {
      type: Number,
      default: null
    }
  },
  validations: {
    email: { required, email },
    pwd: {
      required,
      minLength: minLength(6)
    },
    firstName: {
      required,
      minLength: minLength(3)
    },
    lastName: {
      required,
      minLength: minLength(3)
    }
  },
  data: () => ({
    content: loginForm.data.concat(dialogJson.data).concat(userJson.data),
    email: '',
    pwd: '',
    firstName: '',
    lastName: '',
    isAdmin: false,
    showPwd: false,
    submitError: false,
    loginErrorMsg: '',
    ConfirmationDialogFunction: () => {}
  }),
  computed: {
    firstNameErrors() {
      const errors = []
      if (!this.$v.firstName.$dirty) return errors
      !this.$v.firstName.required &&
        errors.push(this.getError('firstName_necessary'))
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.lastName.$dirty) return errors
      !this.$v.lastName.required &&
        errors.push(this.getError('firstName_necessary'))
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push(this.getError('email_invalid'))
      !this.$v.email.required && errors.push(this.getError('email_necessary'))
      return errors
    },
    pwdErrors() {
      const errors = []
      if (!this.$v.pwd.$dirty) return errors
      !this.$v.pwd.required && errors.push(this.getError('password_necessary'))
      !this.$v.pwd.minLength &&
        errors.push(this.getError('password_min_length'))
      return errors
    },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  created: function() {
    if (this.mode === 'CREATE') {
      this.ConfirmationDialogFunction = userService.createUser
    }
    if (this.mode === 'UPDATE') {
      this.ConfirmationDialogFunction = userService.updateUser
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitError = true
        this.loginErrorMsg = this.getError('validator_message')
      } else {
        let payload = {
          username: this.email,
          email: this.email,
          password: this.pwd,
          role: 'User',
          firstName: this.firstName,
          lastName: this.lastName
        }
        if (this.mode === 'UPDATE') {
          payload.id = this.userUpdateId
        }
        if (this.isAdmin === true) {
          payload.role = 'Admin'
        }

        return this.ConfirmationDialogFunction(payload)
          .then(() => {
            this.$emit('fetchUsers', {})
            this.show = false
          })
          .catch(e => {
            this.submitError = true
            this.loginErrorMsg = this.getError(e.response.status)
          })
      }
    },
    getError: function(errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    },
    clear() {
      this.$v.$reset()
      this.email = ''
      this.pwd = ''
      this.firstName = ''
      this.lastName = ''
    }
  }
}
</script>
